import { render, staticRenderFns } from "./Competition.vue?vue&type=template&id=b641b81e&scoped=true&"
import script from "./Competition.vue?vue&type=script&lang=js&"
export * from "./Competition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b641b81e",
  null
  
)

export default component.exports